module.exports = __webpack_public_path__ + "img/avatar.f26ee484.png";